import { createSlice, PayloadAction } from '@reduxjs/toolkit'
export enum Rhyme {
  FIVE_WORD = 5,
  SEVEN_WORD = 7
}
export enum Emotion {
  OBJECTIVE = 'objective',
  NEGATIVE = 'negative',
  NEUTRAL = 'neutral'
}
export enum Rhythm {
  FLAT = 'flat',
  OBLIQUE = 'oblique'
}
export interface scoreI {
  coherence: number
  emotion: number
  rhythm: number
}
interface poemI {
  poem: string[][]
  scentenceSelected: Rhyme
  emotionSelected: Emotion
  rhythmSelected: Rhythm
  score: scoreI
}

const initialState: poemI = {
  poem: [],
  scentenceSelected: Rhyme.FIVE_WORD,
  emotionSelected: Emotion.OBJECTIVE,
  rhythmSelected: Rhythm.FLAT,
  score: {
    coherence: 0,
    emotion: 0,
    rhythm: 0
  }
}

export const setPoemSlice = createSlice({
  name: 'setPoem',
  initialState,
  reducers: {
    setPoem: (state, action: PayloadAction<string[][]>) => {
      state.poem = action.payload
    },
    setScentenceSelected: (state, action: PayloadAction<Rhyme>) => {
      state.scentenceSelected = action.payload
    },
    setEmotionSelected: (state, action: PayloadAction<Emotion>) => {
      state.emotionSelected = action.payload
    },
    setRhythmSelected: (state, action: PayloadAction<Rhythm>) => {
      state.rhythmSelected = action.payload
    },
    setScore: (state, action: PayloadAction<scoreI>) => {
      state.score = action.payload
    }
  }
})
export const { setPoem, setScentenceSelected, setEmotionSelected, setRhythmSelected, setScore } =
  setPoemSlice.actions
export default setPoemSlice.reducer
